import { render } from "./NavBar.vue?vue&type=template&id=254b407c"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"
script.render = render

export default script